(function () {
var $444edc911e9e5883$var$lib = {
    node: {
        grid: '.downloads .tile-grid'
    },
    class: {
        single: 'downloads--single'
    }
};
// If the DOM is loaded, check if the download tile-grid has only one element and if so add a class to the parent container
document.addEventListener('DOMContentLoaded', function() {
    var _downloadGrid_parentElement;
    var downloadGrid = document.querySelector($444edc911e9e5883$var$lib.node.grid);
    if ((downloadGrid === null || downloadGrid === void 0 ? void 0 : downloadGrid.children.length) === 1) (_downloadGrid_parentElement = downloadGrid.parentElement) === null || _downloadGrid_parentElement === void 0 ? void 0 : _downloadGrid_parentElement.classList.add($444edc911e9e5883$var$lib.class.single);
});

})();
//# sourceMappingURL=download.min.js.map
